import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        const error = {
          status: 'error',
          statusText:
            err.statusText.toLowerCase() !== 'ok'
              ? 'Unknown error'
              : err.statusText,
          message: {
            type: err.type,
            url: err.url,
            status: err?.error?.errors?.detail || err.status,
            statusText: err.statusText,
          },
        };

        if (err.error.message) {
          error.message = err.error.message;
        }

        return throwError(error);
      })
    );
  }
}
